import React from "react";
import { BottomSheet } from "react-spring-bottom-sheet";
import "./SortBySheet.scss";

const SortBySheet = (props) => {
  const { showSortBySheet, setShowSortBySheet, handleSort, sortOption } = props;
  const options = [
    {
      label: "Recommended",
      value: "",
    },
    {
      label: "Price: Low to High",
      value: "lowToHigh",
    },
    {
      label: "Price: High to Low",
      value: "highToLow",
    },
  ];
  return (
    <BottomSheet
      open={showSortBySheet}
      onDismiss={() => setShowSortBySheet(false)}
      className="priceBreakdown__bottomSheetMain"
    >
      <div className="bottomsheet__sortby">
        <div className="bottomsheet__sortby__header">
          <div className="bottomsheet__sortby__header__title">Sort by</div>
        </div>
        <div className="bottomsheet__sortby__content">
          {options.map((option, index) => (
            <div
              key={index}
              className={`bottomsheet__sortby__content__option ${
                option?.value === sortOption && "selected"
              }`}
              onClick={() => handleSort({ target: { value: option?.value } })}
            >
              {option.label}
            </div>
          ))}
        </div>
      </div>
    </BottomSheet>
  );
};

export default SortBySheet;
